export default "__VITE_ASSET__DqudVAan__"